import CloseIcon from "@/assets/CloseIcon";
import { ReactNode } from "react";

export const Modal = ({
  showModal,
  children,
  onClose,
  showClose = true,
}: {
  showModal: boolean;
  onClose: () => void;
  children: ReactNode;
  showClose?: boolean;
}) => {
  return showModal ? (
    <div
      className="fixed inset-0 z-modalOverlay w-full bg-black bg-opacity-50  md:inset-0 md:flex md:items-center md:justify-center"

    >
      <div
        className="absolute bottom-0 left-0 right-0 flex flex-col gap-6 rounded-t-3xl border-[0.8px] border-[#878C90]/30 bg-white p-4 md:relative md:bottom-auto md:left-auto md:right-auto md:w-full md:max-w-[514px] md:rounded-[12px] md:border md:border-[#878C904D] md:p-8 md:shadow-[0px_1px_26.8px_0px_#0000001F]"
        onClick={(e) => e.stopPropagation()}
      >
        {showClose && (
          <div
            className="absolute right-4 top-4 flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[30px] bg-[#F7F9FA] md:right-8 md:top-8"
            onClick={onClose}
          >
            <CloseIcon onClick={onClose} />
          </div>
        )}
        {children}
      </div>
    </div>
  ) : null;
};
